const initState = {
    successFetching: false,
    errorFetching: false,
    data: [],
  };
  
  export default initState;
  